<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-08 23:21:04
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-19 11:04:03
 * @FilePath: /chaoyongtuan/src/components/business/TableColumnCustom/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<el-popover placement="left" :width="231" trigger="click" popper-class="custom-wrapper">
			<div class="flex-row-center-between font-h4-regular yx-color-text-primary p-16 yx-border-bottom">
				<span>表头设置</span>
				<div></div>
			</div>
			<div class="content pb-16 pl-16 pr-16">
				<div class="flex-row-center-between mt-12" v-for="item in tableData" :key="item.key">
					<el-tooltip placement="top" :content="item.label" v-ak-tooltip-auto-show>
						<div class="flex-1 ml-8 yx-color-text-primary font-h4-regular line-ellipsis">
							{{ item.label }}
						</div>
					</el-tooltip>
					<div class="mr-4">
						<el-switch active-color="#2475FF" inactive-color="#C9CDD4" :disabled="item.disabled" v-model="item.show" @change="save"></el-switch>
					</div>
				</div>
			</div>
			<div slot="reference" class="yx-color-text-regular font-h6-regular cursor-pointer hover" @click="visible = true">
				<i class="el-icon-setting"></i>
				<span class="ml-6">自定义表头</span>
			</div>
		</el-popover>
	</div>
</template>

<script>
import { setFieldShow } from '@/api/common';
export default {
	props: {
		columns: {
			type: Array,
			default: () => [],
		},
		list_type: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			tableData: [],
		};
	},
	methods: {
		async init() {
			this.tableData = Object.assign([], this.columns);
		},
		async save() {
			const { list_type } = this;
			const data = Object.assign([], this.tableData);
			const filterArr = data.filter(item => item.show);
			const show_head_list = filterArr.map(item => item.key);
			this.$emit('columnsChange', filterArr);
			await setFieldShow({ show_head_list, list_type });
		},
	},
	created() {
		this.init();
	},
};
</script>
<style lang="less" scoped>
.content {
	max-height: 450px;
	overflow-y: auto;
	&::-webkit-scrollbar {
		width: 6px;
		margin-left: 2px;
	}
	&::-webkit-scrollbar-thumb {
		height: 26px;
		border-radius: 3px;
		background-color: @color-gy6;
	}
}
/deep/ .el-switch__core {
	width: 38px !important;
}
</style>
<style lang="less" scoped>
.custom-wrapper {
	padding: 0px;
}
</style>
